import { userApi } from './index';
import { config } from '../config';
import { IConfigForm } from '../../../models/Survey';

interface GetgetFormConfigProps {
  id: string;
  orderId: string;
  userId: string;
  lang?: string;
}

interface IQuestion {
  Rate: string | number;
  QuestionID: string | number;
}

export interface SurveyForm {
  id: string;
  body: { commonReview: string | number; rates: IQuestion[] };
  orderId: string;
  userId: string;
}

export const surveyApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    getFormConfig: build.query<IConfigForm, GetgetFormConfigProps>({
      query: ({ id, orderId, userId }) => ({
        url: config.SURVEY.FORM(id),
        params: {
          orderId,
          userId,
        },
      }),
    }),
    sendSurveyForm: build.mutation<{ success: boolean }, SurveyForm>({
      query: ({ body, id, orderId, userId }) => ({
        url: config.SURVEY.FORM(id),
        method: 'POST',
        body,
        params: {
          orderId,
          userId,
        },
      }),
    }),
  }),
});
